var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c("content-creator", {
        attrs: {
          settings: _vm.getBlobContents(
            `constructed-page--${_vm.pageid}-cc--${_vm.slice.data.ccid}`
          ),
          permissions: _vm.contentCreatorPermissions,
          "is-visible": _vm.editContentCreator,
          filestore: _vm.websitefilestore,
          name: `constructed-page--${_vm.pageid}-cc--${_vm.slice.data.ccid}`,
        },
        on: {
          updateBlob: (data) =>
            _vm.saveBlob(
              `constructed-page--${_vm.pageid}-cc--${_vm.slice.data.ccid}`,
              data
            ),
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }